export default __webpack_public_path__ + "static/mc-reassign-contacts-dd7aa498a7a6e69e41d34c14fb346c47.mp4";